import React from "react";
import { ShareBtnProps } from "./ShareButton.types";

import { useTranslation, I18nextProvider } from "react-i18next";
import instance from "../../utils/i18n";

import "@esri/calcite-components/dist/components/calcite-button";
import { CalciteButton } from "@esri/calcite-components-react";
import { isIOS } from "react-device-detect";
import styled from "styled-components";

const StyledSpan = styled.span`
  padding: 1px 0;
  box-sizing: border-box;
`;

const onShareClick = (shareUrl: string) => {
  if (navigator.share) {
    navigator
      .share({
        title: document.title,
        url: shareUrl,
      })
      .catch(console.error);
  } else {
    navigator.clipboard
      .writeText(shareUrl)
      .then(() => alert("The address is copied to the clipboard!"))
      .catch(console.error);
  }
};

const ShareButton = ({ shareUrl, shareText }: ShareBtnProps) => {
  const { i18n } = useTranslation("components", { i18n: instance });

  return (
    <I18nextProvider i18n={i18n}>
      <div className="share-btn">
        <CalciteButton
          class="lib-neutral-button"
          id="share-btn"
          onClick={() => onShareClick(shareUrl)}
          appearance="outline"
          iconStart={isIOS ? "share-ios" : "share"}
          kind="neutral"
          scale="m"
          style={
            {
              backgroundColor: "#FFFFFF",
              color: "#1A19BC"
            } as React.CSSProperties
          }
        >
          <StyledSpan>{shareText}</StyledSpan>
        </CalciteButton>
      </div>
    </I18nextProvider>
  );
};

export default ShareButton;